// CLDR plural categories for the 13 admin UI locales, reduced to the cases
// our strings actually need. tp() appends the returned category to the lookup
// key ("plans.showing" + "_one"/"_other" …), so a dictionary only has to
// carry the forms its language really uses.
//
// Categories per locale (integer counts only — every count we format is a
// whole number from Array.length / stats):
//   zh-CN zh-TW ja ko          → other
//   en de es it nl pt-PT       → one / other
//   fr                         → one covers 0 and 1 (CLDR fr: i = 0,1)
//   uk                         → one / few / many (other for fractions)
//   pl                         → one / few / many (other for fractions)
export function pluralCategory(locale, n) {
  const v = Math.abs(Math.floor(Number(n) || 0));
  switch (locale) {
    case 'zh-CN':
    case 'zh-TW':
    case 'ja':
    case 'ko':
      return 'other';
    case 'fr':
      return v <= 1 ? 'one' : 'other';
    case 'uk': {
      const mod10 = v % 10;
      const mod100 = v % 100;
      if (mod10 === 1 && mod100 !== 11) return 'one';
      if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return 'few';
      return 'many';
    }
    case 'pl': {
      if (v === 1) return 'one';
      const mod10 = v % 10;
      const mod100 = v % 100;
      if (mod10 >= 2 && mod10 <= 4 && !(mod100 >= 12 && mod100 <= 14)) return 'few';
      return 'many';
    }
    default:
      return v === 1 ? 'one' : 'other';
  }
}
